import './AvailabilityMessage.scss';

interface Props {
	iconColor: string;
	message: string;
	className?: string;
}

export default function AvailabilityMessage({ iconColor, message, className = '' }: Props) {
	return (
		<div className={`${className || 'availMessage'}  availMessage--${iconColor} `}>
			<div className={'availMessage__message'}>{message}</div>
		</div>
	);
}
